import * as React from "react"

function SvgSendEmaiil(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 43 35"
      {...props}
    >
      <defs>
        <filter
          id="send-emaiil_svg__a"
          width="116.9%"
          height="230.4%"
          x="-6.8%"
          y="-65.2%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation={4}
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.068045236 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <path
        fill="currentColor"
        d="M256.27 32.63c-.631 0-1.145-.413-1.146-.92v-5.521l-9.141-2.043c-.399-.09-.717-.318-.877-.622-.289-.552.033-1.19.72-1.423l25.4-8.438a.578.578 0 01.068-.015.617.617 0 01.105-.016l.03-.001a.682.682 0 01.223.034c.007.002.034.008.064.022a.316.316 0 01.047.027.49.49 0 01.115.088c.012.012.026.024.035.035a.49.49 0 01.081.172c.006.026.007.055.006.085 0 .015-.002.03-.003.043a.142.142 0 01-.005.036l-4.333 16.55c-.155.581-.803 1.002-1.54 1.002-.11 0-.22-.01-.331-.028a1.788 1.788 0 01-.538-.181l-5.408-2.9-2.58 3.558c-.205.281-.583.456-.987.457l-.005-.001zm-.021-.921c0 .009.01.016.021.016l2.632-3.612-2.653-1.423v5.019zm9.623-.949a.508.508 0 00.246.06c.211 0 .397-.121.44-.287l3.967-15.15-13.933 10.403 9.28 4.974zm-19.614-7.824c-.11.038-.164.144-.115.236.027.05.08.089.146.104l9.245 2.066 13.236-9.884-22.512 7.478z"
        filter="url(#send-emaiil_svg__a)"
        transform="translate(-237 -7.63)"
      />
    </svg>
  )
}

export default SvgSendEmaiil
